var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes, Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { MenuComponent } from '@src/_metronic/assets/ts/components';
import DistributionIndex from './Distribution/Distribution';
import { ProtectedRoute } from '@src/app/helper';
import DistributionKeep from './KeepDistribution/KeepDistribution';
var DistributionPage = function () {
    //getdata
    var _a = useState([]), DistributionData = _a[0], setDistributionData = _a[1];
    useEffect(function () {
        MenuComponent.reinitialization();
    }, [DistributionData]);
    return (_jsx(Routes, { children: _jsxs(Route, __assign({ element: _jsx(Outlet, {}) }, { children: [_jsx(Route, { path: '/distribution/', element: _jsx(ProtectedRoute, { permission: 'community.distribution.view', children: _jsx(DistributionIndex, {}) }) }), _jsx(Route, { path: '/distributionkeep/', element: _jsx(ProtectedRoute, { permission: 'community.distributionkeep.view', children: _jsx(DistributionKeep, {}) }) })] })) }));
};
export default DistributionPage;
